import { CONFIG } from '../config.js';
import { ThemeToggle } from './ThemeToggle.jsx';

export const Header = () => (
  <header className="header">
    <div className="header-content">
      {CONFIG.logoImage ? (
        <img src={CONFIG.logoImage} alt={CONFIG.businessName} className="logo-img" />
      ) : (
        <div className="logo">{CONFIG.logoText}</div>
      )}
      <h1>Pedido de presupuesto</h1>
      <div className="header-spacer" />
      <ThemeToggle />
    </div>
  </header>
);
